// We exclude certain partners that are either in the `test`/prelaunch phase,
// or are legacy/deprecated partners which shouldn't be shown in the list.
export const EXCLUDED_PARTNER_ID_LIST = [
  // Demo or Legacy
  128, 231, 831, 791,
] as const
